export var reduxKey = '@@DUPERBROWSE';
export var actionKey = '@@DUPERBROWSE';
export var initialState = {
    streamStack: [],
    isSessionActive: false,
    isHistoryManagementEnabled: true,
};
export var FEEDBACK_PAGE_DUPERBROWSE_STREAMID = "".concat(reduxKey, ":FB:STREAM");
export var FEEDBACK_PAGE_DUPERBROWSE_ITEMID = "".concat(reduxKey, ":FB:ITEM");
//# sourceMappingURL=constants.js.map